<template>
    <div id="registerTotal">
        <header class="registerHeader">
            <div class="main-container">
                <h1 class="left_h">
                    <a class="logoImg" href="javascript:;" @click="toIndex">
                        <img src="../../assets/images/topBar1/logoIcon.png"/>
                    </a>
                    <span v-if="isForgetPage">忘记密码</span>
                    <span v-else>修改密码</span>
                </h1>
                <div class="right_h">
                    <a href="javascript:;" @click="toHelp" class="help">帮助中心</a>
                    <span class="line"></span>
                    <a href="javascript:;" class="wechat">微信服务号</a>
                </div>
            </div>
        </header>
        <div class="main-container">
            <div class="container">
                <section class="small-container">
                     <h3 class="iconfont iconxiala" v-if="isForgetPage">忘记密码</h3>
                     <h3 class="iconfont iconxiala" v-else>修改密码</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                    <el-form status-icon inline :model="userRequestVO" :rules="userRequestVORules" ref="userRequestVO" :label-width="formLabelWidth">
                        <el-row>
                            <template v-if="isForgetPage">
                                <el-col :span="24">
                                    <el-form-item label="登录名：" prop="userName" class="noMarginBottom">
                                        <el-input class="minWidth" size="mini" type="text" :maxlength="11" v-model="userRequestVO.userName" auto-complete="off"></el-input>
                                    </el-form-item>
                                </el-col>
                            </template>
                            <template v-else>
                                <el-col :span="24">
                                    <el-form-item label="企业名称：" prop="companyName" class="noMarginBottom">
                                    {{suppliersVO.companyName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="登录名：" prop="userName" class="noMarginBottom">
                                    {{userRequestVO.userName}}
                                    </el-form-item>
                                </el-col>
                            </template>

                            <el-col :span="24">
                                <el-form-item label="验证码：" prop="verificationCode" class="noMarginBottom veriCodeItem">
                                    <el-input v-model="userRequestVO.verificationCode" class="minWidth" size="mini" placeholder="请输入收到的验证码"></el-input>
                                    <el-button  @click="sendCode" size="mini" class="sendCode" :loading="isSendLoading">发送验证码</el-button>
                                    <!-- <span class="countDown">60s</span> -->
                                    <span class="countDown" style="display:none;">60s</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="密码：" prop="password" class="noMarginBottom">
                                    <el-input v-model.trim="userRequestVO.password"
                                            type="password"
                                            size="mini"
                                            class="minWidth"
                                            placeholder="密码由6－20个英文字母(区分大小写)或数字组成"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="再次输入密码：" prop="enPassword" class="noMarginBottom">
                                    <el-input v-model.trim="userRequestVO.enPassword"
                                            type="password"
                                            size="mini"
                                            class="minWidth"
                                            placeholder="请再输入一遍您上面填写的密码"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </section>
                <section class="small-container">
                    <div style="text-align: left; margin-bottom: 10px;margin-left: 250px;">
                        <el-button type="primary" size="mini" @click="toIndex">取消</el-button>
                        <el-button type="primary" size="mini" @click="submit()">提交</el-button>
                    </div>
                </section>
            </div>
        </div>
    </div>

</template>
<script>
    import md5 from 'js-md5';
    export default {
        name: "change-pwd",
        props: {
            detailType: {
                type: String
            },
            id: {
                type: String
            }
        },
        data(){
            return{
                isForgetPage: this.$route.query.isForgetPage == 1, //true,
                supplierId: window.sessionStorage.getItem('loginId'),
                isSendLoading: false,//是否显示loading状态，发送验证码

                formLabelWidth: '200px',

// 个人信息Start
                userRequestVO:{
                    userName: '',
                    password: '',//密码
                    enPassword: '',
                    verificationCode: '',//验证码
                    codeKey: '',//验证码key
                    logoAttachement: [],
                },
// 个人信息End
                suppliersVO: {
                    companyName: '',
                },
                userRequestVORules: {
                    userName: [
                        { required: true, message: '登录账号为手机号'},
//                        { validator: 'regexp', pattern: /^[0-9]{11}$/, message: '手机号码格式不正确', trigger: 'blur'},
                        {validator: this.validateUserFormat, trigger: 'blur'},
                        {validator: this.validateUser, trigger: 'blur'},
                    ],
                    password:[
                        {required: true, message: '请输入登录密码', trigger: 'blur'},
                        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'},
                        {validator: this.validatePass, trigger: 'blur'}
                    ],
                    enPassword: [
                        {required: true, message: '请再次输入登录密码', trigger: 'blur'},
                        {
                            validator: 'regexp',
                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
                            message: '密码为6-20位数字和字母的组合',
                            trigger: 'blur'
                        },
                        {validator: this.validatePass2, trigger: 'blur'}
                    ],
                    verificationCode: [{
                        required: true,
                        message: '请输入验证码'
                    }],
                },
            }
        },
        created(){
            if(!this.isForgetPage){
                this.getSupplierDetail();
            }
        },
        mounted(){
        },
        methods:{
          /* 修改密码 */
            submit(){
                let _this = this;
                this.$refs.userRequestVO.validate((valid) => {
                    if(valid){
                        _this.$root.postHttp('/v1/login/public/restFindPassword',{
                            "userName":_this.userRequestVO.userName,
                            "password": md5(_this.userRequestVO.password),
                            "verificationCode": _this.userRequestVO.verificationCode
                        },function(res){
//                            console.log('submit')
                            _this.$alert('修改密码成功', '提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {
                                    window.sessionStorage.setItem('token','');
                                    window.sessionStorage.setItem('refresh_token','');
                                    let currentUrl = (window.location.href).split('?')[0];
                                    _this.$router.push('/');
                                    _this.$root.isLogin = false;
                                //    _this.$router.push('/login/masterCenter');
                                }
                            });
                        })
                    } else {
                        this.$alert('请完成必填信息的填写！',{
                            type: 'warning'
                        });
                    }
                });
            },
            toIndex(){
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            toLogin(){
                this.$router.push('/login/masterCenter');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            sendCode(){//发送验证码
                var _this = this;
                var countDownEl = document.querySelector('.countDown');
                var sendCodeEl = document.querySelector('.sendCode');
                _this.$refs.userRequestVO.validateField('userName',function(err){
                    if(!err){//如果没有错误信息，就代表手机号验证通过了，就发送验证码；
                        _this.isSendLoading = true;
                       _this.$root.getHttp(`v1/login/public/sendSmsCode/${_this.userRequestVO.userName}`,function(res){
//                           console.log('验证码',res);
                           _this.isSendLoading = false;
                           countDownEl.style.display = 'inline-block';//发送成功,显示倒计时；
                           sendCodeEl.style.display = 'none';
                           var time = setInterval(function(){
                               if(parseInt(countDownEl.innerHTML) == 1){
                                   countDownEl.innerHTML = '60S';
                                   countDownEl.style.display = 'none';
                                   sendCodeEl.style.display = 'inline-block';
                                   clearInterval(time);
                                   return;
                               }
                               countDownEl.innerHTML = parseInt(countDownEl.innerHTML)-1 + 'S';
                           },1000);

                       })
                    } else {
                        console.log('error')
                    }
                })
            },
            validatePass2(rule, value, callback){//验证确认密码
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.userRequestVO.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            getSupplierDetail(){
                let that = this;
                this.$root.getHttp('/v1/sSuppliers/getOutSSuppliersHS/'+this.supplierId, (res) => {
                    that.userRequestVO = res.data.data.userRequestVO;
                    that.suppliersVO = res.data.data.suppliersVO;
                    that.isCanSend = true;
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/_var.scss';
    @import "../../assets/iconfont/iconfont.css";

    /*头部导航*/
    .registerHeader {
        background: #fff;
        & .main-container {
            overflow: hidden;
            padding: 18px 0;
            height: 80px;
            box-sizing: border-box;
            line-height: 34px;
        }
        & .left_h {
            float: left;
            & .logoImg {
                display: inline-block;
                vertical-align: middle;
                & img {
                    /*width: 240px;*/
                    height: 29px;
                }
            }
            & span {
                margin-left: 20px;
                font-size: 16px;
            }
        }
        & .right_h {
            float: right;
            & .help {
                display: inline-block;
                padding: 0 20px 0 25px;
                background: url('../../assets/images/register/icon01.png') no-repeat left center;
            }
            & .help:hover,
            & .wechat:hover {
                color: $--text-color-light;
            }
            & .wechat {
                display: inline-block;
                padding: 0 0 0 43px;
                background: url('../../assets/images/register/icon02.png') no-repeat 15px center;
            }
            .line {
                display: inline-block;
                width: 1px;
                height: 14px;
                background: $--text-color-lighter;
            }
        }
        & a {
            font-size: 14px;
            color: $--text-color-lighter;
        }
    }
    /*banner*/
    #registerTotal .banner {
        margin: 0 0 30px;
        & img {
            width: 100%;
            height: 150px;
        }
    }

    .main-container{
        width: 1120px;
        text-align: left;
    }
    .container /deep/{
        padding-bottom: 15px;
        background-color: #ffffff;

        & .el-form-item__content {
            & .countDown {
                background: #cb1235;
                position: absolute;
                right: -100px;
                top: 4px;
                width: 88px;
                height: 32px;
                line-height: 32px;
                cursor: pointer;
                color: #fff;
                border-radius: 3px;
                text-align: center;
            }
        }

        & .unit {
            width: 100px;
            margin-right: 5px;
        }

        & .tip {
            margin-left: 10px;
            color: $--primary-color;
            font-size: 12px;
        }

         & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        & .dele {
            position: absolute;
            top: 3px;
            right: 25px;
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }

        & .naturalForm  {
            // padding: 20px 10px 5px;
            // padding-left: 0px;
            // padding-right: 26px;
            // border: 1px solid #dcdfe6;
            // border-radius: 3px;
            // margin-bottom: 20px;
        }

        & h4{
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
            position: relative;
            .dele {
                top: 0px;
            }
        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }

        .attachmentForm {
            position: relative;
            .el-form-item__content {
                width: 250px;
                .file-name {
                    max-width: 174px;
                }
            }
        }

        .remarkForm {
            width: 100%;
            .el-form-item__content {
                width: calc(100% - 250px);
            }
        }

        .el-form-item__error {
            width: 250px;
        }

        .el-input__inner {
            border: none;
            border-bottom: 1px solid #C4C4C4;
            border-radius: 0px;
        }

        .el-input.is-disabled .el-input__inner {
            background-color: white;
        }

        .el-form-item {
            width: 100%;
        }
        .el-form-item__error {
            width: 300px;
            padding: 0;
        }

        .el-form-item__label, .el-form-item__content{
            line-height: 33px;
        }
    }
    .box-card{
        margin-bottom: 15px;
    }
    .minWidth{
        width: 250px;
    }

    h3{
        // background-color: #ececec;
        padding: 5px 20px;
        margin: 0;
        // margin-top: 10px;
        position: relative;
    }

    .iconxiala::before {
        position: absolute;
        left: -5px;
        font-size: 20px;
    }

    .colorLine {
        margin-bottom: 20px;
        padding-left: 20px;
    }

    h2 {
        font-size: 13px;
        margin-left: 20px;
    }
    .noMarginBottom{
        // margin-bottom: 0!important;
        margin-bottom: 15px!important;
        .tipWrap {
            position: relative;
            min-width: 250px;
            .tips {
                position: absolute;
                top: 16px;
                left: 100px;
                padding-left: 20px;
                font-size: 12px;
                color: $--text-color-light;
                background: url('../../assets/images/register/tip.png') no-repeat left center;
            }
        }
    }


    /*注册须知*/
    #article {
        & .el-dialog {
            border-radius: 15px;
        }
        & .el-dialog__header {
            text-align: left;
            font-weight: bold;
            border-bottom: 1px solid $--text-color-light;
        }
        .el-dialog__title {
            padding-left: 30px;
            background: url('../../assets/images/register/icon_tit.png') no-repeat 0 1px;
        }
        .el-dialog--center .el-dialog__body {
            height: 320px;
            overflow-y: scroll;
        }
        & .center {
            text-align: center;
        }
        & section {
            margin-top: 15px;
            padding: 10px;
            color: $--primary-color;
            border: 1px solid $--secondary-fill-color;
        }
        & .padd {
            padding: 5px 0;
        }
        & .indent {
            text-indent: 28px;
        }
        & .indent2 {
            text-indent: 38px;
            /*padding: 0 14px;*/
        }
        & .readed {
            /*margin-top: 20px;*/
            padding: 15px;
            border-top: 1px dashed $--text-color-lighter;
            text-align: left;
        }
        & .el-button{
            padding: 10px 36px;
        }
        & .disagree {
            background: $--text-color-lighter;
            border: none;
        }
        & .el-dialog__footer {
            padding: 0 20px 20px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/common/ChangePwd.vue